import {combineReducers} from 'redux';
import reservationsReducer from './reservations.reducer';

export default combineReducers({
    reservations: reservationsReducer,
});